import { render } from "./NotarialCasesComponent.vue?vue&type=template&id=1be1977f&scoped=true"
import script from "./NotarialCasesComponent.vue?vue&type=script&lang=js"
export * from "./NotarialCasesComponent.vue?vue&type=script&lang=js"

import "./NotarialCasesComponent.vue?vue&type=style&index=0&id=1be1977f&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be1977f"]])

export default __exports__